import styled from 'styled-components';

export const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: ${({ actionContainerPadding }) => actionContainerPadding || '16px'};
  box-sizing: border-box;

  @media print {
    display: none;
  }
`;
